let video = require('../../actions/video');
let bitrix = require('../../actions/bitrix');

module.exports = {
    // если вставить видео на страницу сразу через iframe, то у нас перестаёт работать js, хз почему, фича catbee?
    // поэтому добавляем видео, когда страница уже загрузилась
    onLoad: [
        video.addVideo,
        bitrix.resize
    ]
};



// WEBPACK FOOTER //
// ./signals/video/index.js